const isPayloadValid = (payloadTime) => {
  const now = new Date().getTime();
  const twelveHoursInSeconds = 43200;
  return ((now / 1000) - (payloadTime / 1000)) < twelveHoursInSeconds;
};

export const getParamsFromLocalStorage = (urlParams = {}) => {
  const localStorageParams = localStorage.getItem('urlParams');
  let newParams = { ...urlParams, timeSet: new Date().getTime() };
  if (localStorageParams) {
    try {
      const parsedParams = JSON.parse(localStorageParams);
      if (isPayloadValid(parsedParams.timeSet)) {
        newParams = { ...parsedParams, ...newParams };
      }
    } catch (e) {
      console.error(e);
    }
  }
  return newParams;
};

const storeParamsToLocalStorage = (urlParams = {}) => {
  const newParams = getParamsFromLocalStorage(urlParams);
  const stringParams = JSON.stringify(newParams);
  localStorage.setItem('urlParams', stringParams);
};

export const getUrlParams = () => {
  const queryString = window.location.search;
  // eslint-disable-next-line prefer-destructuring
  let host = window.location.host;
  host = host.replace('www.', '');
  const hostArray = host.split('.');
  hostArray.pop();
  const regexForParams = /([^?=&]+)(=([^&]*))?/g;
  const paramsExtracted = queryString.match(regexForParams) || [];
  const subDomainExtracted = hostArray && hostArray.length > 1 ? hostArray[0] : '';
  const reduceParams = (paramObject, currentParam) => {
    const [paramKey, paramValue] = currentParam.split('=');
    return { ...paramObject, [paramKey]: paramValue };
  };
  const initialParams = {
    user_agent: navigator.userAgent,
    referrer: encodeURIComponent(localStorage.getItem('referrer') || document.referrer),
    subDomain: !(['www', 'com', 'io', 'net'].indexOf(subDomainExtracted) >= 0) && !Number.isInteger(+subDomainExtracted) ? subDomainExtracted : '',
  };
  const extractedParams = paramsExtracted.reduce(reduceParams, initialParams);
  if (extractedParams.affid && extractedParams.affid.toString() === '1154') {
    extractedParams.affid = '668';
  }
  storeParamsToLocalStorage(extractedParams);
  return extractedParams;
};

export function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]).toString() === variable.toString()) {
      return decodeURIComponent(pair[1]);
    }
  }
  return false;
}
